// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  ITalkingPointsResourceModel,
  TNewTalkingPoint,
  TPaginatedTalkingPoints,
  TTalkingPoint,
  TTalkingPointsIndexPayload,
} from '~/misc/talking-points-resource/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

export class TalkingPointsResourceModel
  extends DefaultResource
  implements ITalkingPointsResourceModel
{
  protected endpoint = 'talking-points/';

  index(
    payload: TTalkingPointsIndexPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedTalkingPoints> {
    return this.get<TPaginatedTalkingPoints>('', payload, requestConfig);
  }

  show(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<TTalkingPoint> {
    return this.get<TTalkingPoint>(`${id}`, undefined, requestConfig);
  }

  store(
    payload: TNewTalkingPoint,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TTalkingPoint> {
    return this.post<TTalkingPoint>('', payload, requestConfig);
  }

  update(
    id: number,
    payload: TNewTalkingPoint,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TTalkingPoint> {
    return this.patch<TTalkingPoint>(`${id}`, payload, requestConfig);
  }

  destroy(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete(`${id}`, undefined, requestConfig);
  }

  suspend(
    id: number,
    payload: TNewTalkingPoint,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TTalkingPoint> {
    return this.update(id, { ...payload, active: false }, requestConfig);
  }

  activate(
    id: number,
    payload: TNewTalkingPoint,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TTalkingPoint> {
    return this.update(id, { ...payload, active: true }, requestConfig);
  }
}
